import Accordian from "./Accordian";
import {
  BasicInfo,
  EducationalInfo,
  UserControl,
} from "../../Models/SettingModel";
import { useState } from "react";
import Header from "../../Components/Header";
import SidePanel from "../../Components/SidePanel";

export default function Setting() {
  const [hideSidepanel, setHideSidePanel] = useState(true);
  const handleHide = (e) => {
    e.preventDefault();
    setHideSidePanel(!hideSidepanel);
  };

  return (
    <>
      <Header Page={"Settings"} handleHide={handleHide} />
      {/*<!-- top-right search bar -->*/}
      <SidePanel handleHide={handleHide} hide={hideSidepanel} />
      <div class="settings-pro pt-3">
        <div class="container">
          <div class="accordion" id="accordionSE">
            <Accordian Name={"Basic Info"} AccordianData={BasicInfo} />
            <Accordian Name={"User Control"} AccordianData={UserControl} />
            <Accordian
              Name={"Educational Info"}
              AccordianData={EducationalInfo}
            />
          </div>
          {/*   <!--/accordion  -->*/}
        </div>
      </div>
    </>
  );
}
